import {createAction} from 'redux-actions';
import * as Constants from './constants';

export const fetchAllConfigUser = createAction(Constants.FETCH_ALL_CONFIG_USER.REQUEST);
export const updatePrivateSetting = createAction(Constants.UPDATE_USER_CONFIG.REQUEST);
